<div class="card-container" data-cy="history-chart">
  <div class="card-header">
    {{ 'global.instrumentHistoryChartHeader' | translate }}
  </div>

  @if (!preloader) {
    @if (!loadError) {
      @if (!wrongWeights) {
        @if (!weightNull) {
          @if (!noDataAvailable) {
            @if (cardData) {
              <div class="chart-container">
                <canvas
                  baseChart
                  [data]="selectedChartData"
                  [options]="lineChartOptions"
                  [type]="'line'"
                  [legend]="false"
                  >
                </canvas>
              </div>
            }
            <div class="year-switches">
              <div
                class="year-switch"
                [ngClass]="{ 'year-switch--active': selectedYears === 'oneYear' }"
                (click)="updateChart('oneYear')"
                (keydown.space)="selectedYears !== 'oneYear' && updateChart('oneYear')"
                (keydown.enter)="selectedYears !== 'oneYear' && updateChart('oneYear')"
                tabindex="0"
                data-cy="history-chart-1year"
                >
                {{ 'global.chartPeriods.1year' | translate }}
              </div>
              <div
                class="year-switch"
                  [ngClass]="{
                    'year-switch--active': selectedYears === 'threeYears',
                    'year-switch--disabled': availableYearsBack < 3
                  }"
                (click)="availableYearsBack >= 3 && updateChart('threeYears')"
                (keydown.space)="availableYearsBack >= 3 && selectedYears !== 'threeYears' && updateChart('threeYears')"
                (keydown.enter)="availableYearsBack >= 3 && selectedYears !== 'threeYears' && updateChart('threeYears')"
                tabindex="0"
                #button3YContent
                data-cy="history-chart-3years"
                >
                {{ 'global.chartPeriods.3years' | translate }}
              </div>
              <div
                class="year-switch"
                  [ngClass]="{
                    'year-switch--active': selectedYears === 'fiveYears',
                    'year-switch--disabled': availableYearsBack < 5
                  }"
                (click)="availableYearsBack >= 5 && updateChart('fiveYears')"
                (keydown.space)="availableYearsBack >= 5 && selectedYears !== 'fiveYears' && updateChart('fiveYears')"
                (keydown.enter)="availableYearsBack >= 5 && selectedYears !== 'fiveYears' && updateChart('fiveYears')"
                tabindex="0"
                #button5YContent
                data-cy="history-chart-5years"
                >
                {{ 'global.chartPeriods.5years' | translate }}
              </div>
              <div #tooltip3YContainerEl style="display: none;">
                @if (availableYearsBack < 3) {
                  <div class="tooltip-content" data-cy="disabled-3y-tooltip">
                    <div class="disabled-tooltip-text"> {{ 'global.missingChartHistory' | translate }} </div>
                  </div>
                }
              </div>
              <div #tooltip5YContainerEl style="display: none;">
                @if (availableYearsBack < 5) {
                  <div class="tooltip-content" data-cy="disabled-5y-tooltip">
                    <div class="disabled-tooltip-text"> {{ 'global.missingChartHistory' | translate }} </div>
                  </div>
                }
              </div>
            </div>
            @if (chartData && chartData[selectedYears].cumulativePriceAction) {
              <div class="comulative-value pt-1">
                {{ 'chartLabels.comulativeValue' | translate }} {{ chartData[selectedYears].cumulativePriceAction * 100 | number:'1.0-2' }} % {{ 'chartLabels.perAnum' | translate }}
              </div>
            }
          } @else {
            <div class="no-data-container"  data-cy="no-history-data-available">
              {{ 'global.error.noData' | translate }}
            </div>
          }
        } @else {
          <div class="error-text-container" data-cy="null-weight-error">
            {{ 'strategies.instrumentsWith0' | translate }}
          </div>
        }
      } @else {
        <div class="error-text-container" data-cy="wrong-weights-error">
          {{ 'strategies.checksumNot100' | translate }}
        </div>
      }
    } @else {
      <div class="error-text-container" data-cy="load-data-error">
        {{ 'global.error.loadData' | translate }}
      </div>
    }
    <div class="row instruments-container">
      <div class="col-6">
        <div class="table-label table-label--instrument">
          {{ 'global.instrument' | translate }}
        </div>
      </div>
      <div class="col-6">
        <div class="table-label table-label--value">
          {{ 'global.performance' | translate }}
        </div>
      </div>
    </div>
    <hr class="divider">
    @for (dropdown of dropdownData; track $index) {
      <div class="dropdown-container">
        <div class="dropdown-row" data-cy="history-chart-instrument-dropdown">
          <div>
            {{ dropdown.humanName }}
          </div>
          <div>
            {{ (dropdown.performance || dropdown.performance === 0) ? (dropdown.performance | number:'1.0-2') + ' %' : '-' }}
          </div>
        </div>
        <hr class="divider">
      </div>
    }
    @if (dropdownData.length < 1) {
      <div class="empty-instruments">
        <div class="dropdown-row">
          <div>-</div>
          <div>-</div>
        </div>
      </div>
    }
  } @else {
    <libero-preload-spinner></libero-preload-spinner>
  }
</div>
